/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
// import Modal from "react-responsive-modal";

import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import Barcode from "react-barcode";
//import PerfectScrollbar from 'react-perfect-scrollbar';

// import Slider from "react-slick";

import CardList from '../containers/card/CardList';
import CardReg from '../containers/card/CardReg';

class Card extends Component {
  state = {
    index: this.props.childProps.index ? this.props.childProps.index : 0,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onReg = () => {
    const { setCardListShow, setCardRegShow } = this.props;

    setCardListShow(false);
    setCardRegShow(true);
  };
  _onCardRegHide = () => {
    const { setCardListShow, setCardRegShow } = this.props;
    setCardListShow(false);
    setCardRegShow(false);
  };
  _cardStop = (cardNumber) => {
    const { setCardListShow } = this.props;
    setCardListShow(false);
    confirmAlert({
      title: '포인트카드 정지',
      message:
        '해당 카드를 정지 하시겠습니까? 정지된 카드는 온/오프라인에서 사용 할 수 없으며, 정지 해지가 불가합니다.',
      buttons: [
        {
          label: '카드 정지하기',
          onClick: () => {
            this._onCardStop(cardNumber);
          },
        },

        {
          label: '취소',
          onClick: () => {
            setCardListShow(true);
          },
        },
      ],
    });
  };
  _onCardStop = async (cardNumber) => {
    const { setCardListShow, loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._onCardStopApi(cardNumber);
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          toast.success('정상적으로 카드가 정지 처리 되었습니다.');
          setCardListShow(true);
        } else {
          toast.error(
            '카드 정지 처리중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'
          );
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onCardStopApi = (cardNumber) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/cardStop',
        {
          params: {
            userid: loginId,
            cardNumber: cardNumber,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(cardNumber);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (cardNumber) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onCardStop(cardNumber);
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };

  _onChange = (index) => {
    this.setState({
      index,
    });
  };
  render() {
    const { index } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="detail_layer_pop">
          <div className="detail_view cashcard_view">
            <div className="detail_layer_close" onClick={this._onCardRegHide}>
              <img src={imgUrl + '/img/detail_img/close_1.png'} />
            </div>
            <div className="detail_view_layer">
              <div className="detil_top" id="top">
                <div
                  className={
                    index === 0
                      ? 'cashcard_wrap'
                      : 'cashcard_pop_layer4 cashcard_wrap'
                  }
                >
                  <div className="tab_menu">
                    <button
                      type="button"
                      className={index === 0 ? 'active' : null}
                      onClick={() => this._onChange(0)}
                    >
                      <span>나의 포인트카드</span>
                    </button>
                    <button
                      type="button"
                      className={index === 1 ? 'active' : null}
                      onClick={() => this._onChange(1)}
                    >
                      <span>신규 포인트카드 등록</span>
                    </button>
                  </div>

                  <div className="cashcard_body">
                    {index === 0 ? <CardList /> : <CardReg />}

                    <div className="cashcard_btm">
                      <ul>
                        <li>
                          본 캐쉬 카드는 현금과 동일하게 사용할 수 있습니다.
                        </li>
                        <li>
                          본 캐쉬 카드는 충전형으로 재충전이 가능하며,현금과
                          교환되지 않습니다.
                        </li>
                        {/*<li>본 캐쉬 카드로 구매 시 현금 영수증을 받으실 수 있습니다.</li>*/}
                        <li>
                          본 캐쉬 카드의 도난, 분실 등에 대하여 당사는 책임지지
                          않습니다.
                        </li>
                        <li>
                          본 캐쉬 카드는 애니플러스 매장 및 온라인 쇼핑몰에서
                          사용 가능합니다.
                        </li>
                        <li>
                          본 캐쉬 카드 충전금액의 유효기간은 충전일로부터
                          1년입니다.
                        </li>
                        <li>
                          본 캐쉬 카드의 환불은 애니플러스 환불 정책에 따릅니다.
                          <br />
                          (애니플러스 앱 또는 홈페이지 접속 후 환불 규정 확인 후
                          환불신청)
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Card));
